import TransferManifestDetails from '@/pages/(shared)/orders/detail/transferManifest/components/transferManifestDetails';

import {OrderProvider} from '../providers/orderDetailsProvider';

function TransferManifestDetailsPage() {
  return (
    <OrderProvider>
      <TransferManifestDetails />
    </OrderProvider>
  );
}

export default TransferManifestDetailsPage;
